import { Component } from '@angular/core';

@Component({
    selector: 'app-company-valuation',
    template: `<router-outlet></router-outlet>`,
})
export class CompanyValuationPage {}
